export default class Backup {
  constructor(consultationId) {
    this.consultationId = consultationId;
    this.initDatabase();
  }

  initDatabase() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open("VetomaticDB", 1);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        const objectStore = db.createObjectStore("recordings", {
          keyPath: "id",
        });
        objectStore.createIndex("name", "name", { unique: false });
      };

      request.onsuccess = (event) => {
        this.db = event.target.result;
        resolve();
      };

      request.onerror = (event) => {
        console.error("error:", event.target.error);
        reject(event.target.error);
      };
    });
  }

  async injectBlob(blob) {
    await this.initDatabase();
    const name = `Recording_${this.consultationId}`;
    const recordingData = { id: this.consultationId, blob, name };
    this.#getObjectStore().put(recordingData);
  }

  async getRecording() {
    await this.initDatabase();
    const request = this.#getObjectStore("readonly").get(this.consultationId);
    return new Promise((resolve, reject) => {
      request.onsuccess = (event) => {
        const recording = event.target.result;
        resolve(recording);
      };
      request.onerror = (event) => {
        reject(event.target.error);
      };
    });
  }

  async deleteRecording() {
    await this.initDatabase();
    this.#getObjectStore().delete(this.consultationId);
  }

  #getObjectStore(method = "readwrite") {
    const transaction = this.db.transaction("recordings", method);
    return transaction.objectStore("recordings");
  }
}
